<template>
    <div class="drag-container">
      <div style="overflow-x: scroll;height: 78vh">
        <ul class="drag-list">
            <li v-for="stage in stages" class="drag-column" :class="{['drag-column-' + stage.name]: true}" :key="stage.id">
        <span class="drag-column-header">
          <slot :name="stage.id">
            <h2>{{ stage.name }}</h2>
          </slot>
        </span>
                <div class="drag-options"></div>
                <div class="scroll-box scrollbox_delayed">             <!-- Extra div For scrollbar -->
                <ul class="drag-inner-list" ref="list" :data-status="stage.name">
                    <li class="drag-item" v-for="block in getBlocks(stage.id)" :data-block-id="block.id" :key="block.id">
                        <slot :name="block.id">
                            <strong>{{ block.status }}</strong>
                            <div>{{ block.id }}</div>
                        </slot>
                    </li>
                </ul>
                </div>
                <div class="drag-column-footer">
                    <slot :name="`footer-${stage}`"></slot>
                </div>
            </li>
        </ul>
      </div>
    </div>

</template>

<script>

    export default {
        name: 'KanbanBoard',

        props: {
            stages: {},
            blocks: {},
        },
        data() {
            return {

            };
        },

        computed: {
            localBlocks() {
                return this.blocks;
            },
        },

        methods: {
            getBlocks(status) {
                if(this.localBlocks.length){
                    return this.localBlocks.filter(block => block.internalstatus === status);
                }
            }
        },

        mounted() {},
    };
</script>
